import { useSpring, animated as _animated } from 'react-spring';

// react-spring 在 React19 下有类型报错，官方还尚未兼容解决
const animated = _animated as any;

export { useSpring, animated };
